import * as React from 'react';
import { identityReducer } from './identity-reducer';
import { IUseIdentity } from './identity-interfaces';
import { identityInitialState } from './identity-variables';

const IdentityStateContext = React.createContext<IUseIdentity | undefined>(undefined);

type IdentityProviderProps = { children: React.ReactElement }

const IdentityProvider = ({ children }: IdentityProviderProps): JSX.Element => {
	const [identityState, dispatch] = React.useReducer(identityReducer, identityInitialState);
	// NOTE: you *might* need to memoize this value
	// Learn more in http://kcd.im/optimize-context
	const value = { identityState, dispatch };
	return (
		<IdentityStateContext.Provider value={value}>
			{children}
		</IdentityStateContext.Provider>
	);
};

const useIdentity = (): IUseIdentity => {
	const context = React.useContext(IdentityStateContext);
	if (context === undefined) {
		throw new Error('useIdentity must be used within a IdentityProvider');
	}
	return context;
};

export { IdentityProvider, useIdentity };
